import { mergeAttributes } from "@tiptap/core";

import { LibraryImageNode } from "./library-image";

export type LibraryImageExportOptions = {
  imgSrcMap: Record<string, string>;
};

export const LibraryImageBase64Node =
  LibraryImageNode.extend<LibraryImageExportOptions>({
    addOptions() {
      return {
        imgSrcMap: {},
      };
    },

    renderHTML(props) {
      const { HTMLAttributes, node } = props;
      const uuid =
        (HTMLAttributes["data-library-file-uuid"] as string | null) ??
        node.attrs.src;
      const src = uuid ? this.options.imgSrcMap[uuid] : undefined;

      if (!src) {
        return this.parent?.(props) ?? ["img", HTMLAttributes];
      }

      return [
        "img",
        mergeAttributes(HTMLAttributes, {
          src,
          "data-library-file-uuid": uuid,
          alt: HTMLAttributes.alt || "Image",
        }),
      ];
    },
  });
